// Copyright (c) Docugami, Inc. All rights reserved.
import { DOMParser } from '@xmldom/xmldom'
import { DgPrototypeNumbering } from './DgPrototypeNumbering';
import { StringBuilder } from 'utils/StringBuilder';

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// This module is more or less equivalent to TransformDgmlToWml.cs
//
// One key difference is that TransformDgmlToWml.cs handles hyperlinks, because we generate hyperlinks in the
// generated abstract.
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////

/*eslint-disable */

// Note: the following const have eslint-disable because they form the whole of the Open-Xml-Sdk for JavaScript API.
// Most modules will use only a subset of the API, but disabling portions of the API leads to friction when writing
// code.  Disabling eslint for these variables removes the error indicating that a variable is assigned a value but
// never used.  If we ever re-write these modules in TypeScript, then the public API will change significantly.

const Enumerable = require("../../../../../utils/linq");
const Ltxml = require('../../../../../utils/ltxml.js');
Ltxml.DOMParser = DOMParser

const openXml = require('../../../../../utils/openxml');

const XAttribute = Ltxml.XAttribute;
const XCData = Ltxml.XCData;
const XComment = Ltxml.XComment;
const XContainer = Ltxml.XContainer;
const XDeclaration = Ltxml.XDeclaration;
const XDocument = Ltxml.XDocument;
const XElement = Ltxml.XElement;
const XName = Ltxml.XName;
const XNamespace = Ltxml.XNamespace;
const XNode = Ltxml.XNode;
const XObject = Ltxml.XObject;
const XProcessingInstruction = Ltxml.XProcessingInstruction;
const XText = Ltxml.XText;
const XEntity = Ltxml.XEntity;
const cast = Ltxml.cast;
const castInt = Ltxml.castInt;

const W = openXml.W;
const W14 = openXml.W14;
const W15 = openXml.W15;
const NN = openXml.NoNamespace;
const wNs = openXml.wNs;
const FLATOPC = openXml.FLATOPC;
/*eslint-enable */

export function transformAbstractXmlToWml(wmlDocument: any, theParagraphXElement: any, beforeSelectionPara: any, abstractXmlV2ToInsertArray: any, afterSelectionPara: any): any
{
    const body = wmlDocument.descendants(W.body).firstOrDefault();
    const pPr = theParagraphXElement.descendants(W.pPr).firstOrDefault();
    const rPr = theParagraphXElement.descendants(W.rPr).firstOrDefault();

    // get rid of bold
    rPr.descendants().where((e: any) => e.name === W.b || e.name === W.bCs).forEach((z: any) => z.remove());

    const styleDefinitionsPart = wmlDocument.elements(FLATOPC.part).first((p: any) => p.attribute(FLATOPC.contentType)?.value === openXml.contentTypes.styles);
    const styleDefinitionsRootElement = styleDefinitionsPart.element(FLATOPC.xmlData).element(W.styles);

    const numberingPart = wmlDocument.elements(FLATOPC.part).first((p: any) => p.attribute(FLATOPC.contentType)?.value === openXml.contentTypes.numberingDefinitions);
    const numberingDefinitionsRootElement = numberingPart.element(FLATOPC.xmlData).element(W.numbering)

    var newContent = doTransform(abstractXmlV2ToInsertArray, false, styleDefinitionsRootElement, numberingDefinitionsRootElement, pPr, rPr);

    // beforeSelectionPara or afterSelectionPara might be null.  that is ok.
    body.replaceAll(beforeSelectionPara, newContent, afterSelectionPara);

    return wmlDocument;
}

function doTransform(abstractXmlV2ToInsertArray: any[], inTable: boolean, styleDefinitionsXDoc: any, numberingDefinitionsXDoc: any, pPr: any, rPr: any)
{
    var newContent: any[] = [];
    for (var i = 0; i < abstractXmlV2ToInsertArray.length; ++i)
    {
        const element = abstractXmlV2ToInsertArray[i];
        if (element.nodeType === 'Element')
        {
            const elementName = element.name.toString();
            if (elementName === "table")
            {
                const table = convertHtmlTableToWordTable(element, styleDefinitionsXDoc, numberingDefinitionsXDoc, inTable);
                newContent.push(table);
            }
            else if (elementName === "div" && element.elements().any((c: any) =>
                {
                    const childElementName = c.name.toString();
                    return childElementName === "p" || childElementName === "table" || childElementName === "ol" || childElementName === "ul";
                }
            ))
            {
                const transformed = doTransform(element.elements().toArray(), inTable, styleDefinitionsXDoc, numberingDefinitionsXDoc, pPr, rPr);
                newContent.push(transformed);
            }
            else if (elementName === "Paragraph" || elementName === "div" || elementName === "h1" || elementName === "p")
            {
                const para = convertParagraphElementToWordParagraph(element, inTable, pPr, rPr);
                newContent.push(para);
            }
            else if (elementName === "ol" || elementName === "ul")
            {
                const listConverted = convertListElementToWordMarkup(element, styleDefinitionsXDoc, numberingDefinitionsXDoc);
                newContent.push(listConverted);
            }
        }
    }
    return newContent;
}

function convertParagraphElementToWordParagraph(paragraph: any, inTable: boolean, pPr: any, rPr: any): any
{
    const isHeading: boolean = paragraph.name.toString() === "h1" && !inTable;
    const text: string = paragraph.value;
    const newPara = new XElement(W.p,
        isHeading ?
            new XElement(W.pPr,
                isHeading ? new XElement(W.pStyle, new XAttribute(W.val, "Heading1")) : null,
                new XElement(W.spacing, new XAttribute(W.after, 160)),
                new XElement(W.ind, new XAttribute(W.left, 720))
            )
        : pPr,
        new XElement(W.r,
            new XElement(W.t, text)
        )
    );
    return newPara;
}

function convertListElementToWordMarkup(listElement: any, styleDefinitionsXDoc: any, numberingDefinitionsXDoc: any): any
{
    const listStyleAttribute: any = listElement.attribute("style");
    const listStyleType: string|null = listStyleAttribute?.value;

    const numId: number|null = addAbstractNumToNumberingDefinitionsPart(styleDefinitionsXDoc, numberingDefinitionsXDoc, listStyleType);
    if (numId === null)
    {
        const listContent: any[] = listElement
            .elements()
            .select((li: any) =>
            {
                const text: string = li.value;
                const p: any = new XElement(W.p,
                    new XElement(W.pPr,
                        new XElement(W.spacing, new XAttribute(W.after, 160)),
                        new XElement(W.ind, new XAttribute(W.left, 720))
                    ),
                    new XElement(W.r,
                        new XElement(W.t, text)
                    )
                );
                return p;
            })
            .toArray();
        return listContent;
    }
    else
    {
        const listContent: any[] = listElement
            .elements()
            .select((li: any) =>
            {
                const text: string = li.value;
                const p: any = new XElement(W.p,
                    new XElement(W.pPr,
                        new XElement(W.pStyle, new XAttribute(W.val, "ListParagraph")),
                        new XElement(W.numPr,
                            new XElement(W.ilvl, new XAttribute(W.val, 0)),
                            new XElement(W.numId, new XAttribute(W.val, numId))
                        ),
                        new XElement(W.spacing, new XAttribute(W.after, 160)),
                        new XElement(W.ind, new XAttribute(W.left, 720))
                    ),
                    new XElement(W.r,
                        new XElement(W.t, text)
                    )
                );
                return p;
            })
            .toArray();
        return listContent;
    }
}

function addAbstractNumToNumberingDefinitionsPart(styleDefinitionsXDoc: any, numberingDefinitionsXDoc: any, listStyleValue: string|null): number|null
{
    let listStyle: string|null = null;
    const split = listStyleValue?.split(':');
    if (split?.length === 2)
    {
        listStyle = split[1].trim();
    }

    if (!listStyle)
    {
        listStyle = "decimal";
    }
    addListParagraphStyleIfMissing(styleDefinitionsXDoc);
    var nextAbstractNumId: number;
    if (numberingDefinitionsXDoc
        .elements(W.abstractNum)
        .any())
    {
        nextAbstractNumId = numberingDefinitionsXDoc
            .elements(W.abstractNum)
            .select((a: any) => Number(a.attribute(W.abstractNumId).value))
            .max() + 1;
    }
    else
    {
        nextAbstractNumId = 0;
    }
    if (DgPrototypeNumbering.abstractNumMarkup[listStyle] === null)
    {
        return null;
    }
    const abstractNumString: string = DgPrototypeNumbering.abstractNumMarkup[listStyle];
    const abstractNum: any = XElement.parse(abstractNumString);
    abstractNum.setAttributeValue(W.abstractNumId, nextAbstractNumId);

    const randNum: number = Math.floor(Math.random() * 0xffffffff);
    const randStr: string = randNum.toString(16);

    abstractNum
        .elements(W.nsid)
        .forEach((a: any) => a.attribute(W.val).value = randStr);

    const lastAbstractNum: any = numberingDefinitionsXDoc
        .elements(W.abstractNum)
        .lastOrDefault();
    if (lastAbstractNum !== null)
    {
        lastAbstractNum.addAfterSelf(abstractNum);
    }
    else
    {
        numberingDefinitionsXDoc
            .addFirst(abstractNum);
    }
    let nextNumId: number;
    if (numberingDefinitionsXDoc
        .elements(W.num)
        .any())
    {
        nextNumId = numberingDefinitionsXDoc
            .elements(W.num)
            .select((a: any) => Number(a.attribute(W.numId).value))
            .max() + 1;
    }
    else
    {
        nextNumId = 1;
    }
    const num: any = new XElement(W.num,
        new XAttribute(W.numId, nextNumId),
        new XElement(W.abstractNumId,
            new XAttribute(W.val, nextAbstractNumId)));
    const lastNum: any = numberingDefinitionsXDoc
        .elements(W.num)
        .lastOrDefault();
    if (lastNum != null)
    {
        lastNum.addAfterSelf(num);
    }
    else
    {
        numberingDefinitionsXDoc
            .add(num);
    }
    return nextNumId;
}

function addListParagraphStyleIfMissing(styleDefinitionsXDoc: any)
{
    if (styleDefinitionsXDoc
        .elements(W.style)
        .any((st: any) => st.attribute(W.type).value === "paragraph" &&
            st.attribute(W.styleId).value === "ListParagraph"))
    {
        return;
    }
    const listParagraphString: string = `<w:style w:type='paragraph'
    w:styleId='ListParagraph'
    xmlns:w='http://schemas.openxmlformats.org/wordprocessingml/2006/main'>
<w:name w:val='List Paragraph'/>
<w:basedOn w:val='Normal'/>
<w:uiPriority w:val='34'/>
<w:qFormat/>
<w:pPr>
<w:ind w:left='1542'
    w:hanging='720'/>
</w:pPr>
</w:style>
`;
    const listParagraphStyle: any = XElement.parse(listParagraphString);
    styleDefinitionsXDoc
        .add(listParagraphStyle);
}

class CellData
{
    CellElement: any|null = null; // this is the td element
    IsColSpanPlaceholder: boolean|null = null;
    IsRowSpanPlaceholder: boolean|null = null;
    RowSpan: number|null = null;
    ColSpan: number|null = null;
}

function convertHtmlTableToWordTable(htmlTable: any, styleDefinitionsXDoc: any, numberingDefinitionsXDoc: any, inTable: boolean)
{
    //================================================================================================================
    // The following code adds "placeholder" cells into the data. We do this to make it easy to properly generate cell
    // addresses for all cells in a table that contain merged cells.

    // the summary of the algorithm is:
    // - the tableArray is actually a List<List<CellData>>, which is essentially a jagged 2 dimensional array that can
    //   grow in any direction as needed.
    // - for every row in the data
    //   - if necessary, add a new row to the array
    //   - for every cell in the row
    //     - find the next location to add a cell into the array
    //     - if the cell is already taken (by a rowspan above) then skip that location
    //     - add the cell to the array
    //     - add the colspan placeholder cells to the array
    //       - if the placeholder cell was already taken, then quit adding colspan placeholder cells
    //     - add the rowspan placeholder cells to the array (if necessary, add new rows to the array)

    // - then, after the above algorithm has run
    //   - regenerate tableDefinitionList
    //   - generate mergedCellsList
    //     - for every cell in the array
    //       - if the cell is not a placeholder cell &&
    //       - if the cell is merged to the right, or merged below
    //         - generate a merged cell, add to list.
    //   - regenerate the table with tableDefinitionList, mergedCellsList
    //================================================================================================================
    let tableArray: CellData[][] = [];
    let yIdx: number = 0;
    htmlTable.element("tbody").elements("tr").forEach((tr: any) =>
    {
        ensureRowInTableArray(tableArray, yIdx);
        const thisRow: CellData[] = tableArray[yIdx];
        let xIdx: number = 0;
        tr.elements("td").forEach((td: any) =>
        {
            let thisCell: CellData|null = null;
            while (true)
            {
                ensureCellInRow(thisRow, xIdx);
                thisCell = thisRow[xIdx];
                ++xIdx;
                if (thisCell.IsColSpanPlaceholder !== true && thisCell.IsRowSpanPlaceholder !== true)
                {
                    break;
                }
            }
            const colspanAtt = td.attribute("colspan");
            const colspan: number|null = colspanAtt !== null ? Number(colspanAtt.value) : null;
            const rowspanAtt = td.attribute("rowspan");
            const rowspan: number|null = rowspanAtt !== null ? Number(rowspanAtt.value) : null;

            thisCell!.CellElement = td;
            thisCell!.IsColSpanPlaceholder = false;
            thisCell!.IsRowSpanPlaceholder = false;
            thisCell!.RowSpan = rowspan;
            thisCell!.ColSpan = colspan;

            if (colspan !== null)
            {
                const nbrPlaceHoldersToAdd: number = Number(colspan - 1);
                for (let i = 0; i < nbrPlaceHoldersToAdd; ++i)
                {
                    ensureCellInRow(thisRow, xIdx);
                    const thisPlaceholder: CellData = thisRow[xIdx];
                    if (thisPlaceholder.IsColSpanPlaceholder === true || thisPlaceholder.IsRowSpanPlaceholder === true)
                    {
                        throw new Error("Invalid colspans or rowspans.  Review source data in detail.");
                    }
                    ++xIdx;
                    thisPlaceholder.CellElement = td;
                    thisPlaceholder.IsColSpanPlaceholder = true;
                    thisPlaceholder.IsRowSpanPlaceholder = false;
                    thisPlaceholder.RowSpan = rowspan;
                }
            }
        })
        for (let x = 0; x < thisRow.length; ++x)
        {
            const cellData2: CellData = thisRow[x];

            if (cellData2.RowSpan !== null)
            {
                const td: any = cellData2.CellElement;
                const rowSpansToAdd: number = Number(cellData2.RowSpan - 1);
                const isColspanOfRootRow: boolean|null = cellData2.IsColSpanPlaceholder;

                const rowToTakeColSpanFrom = tableArray[yIdx];
                const cellToTakeColSpanFrom = rowToTakeColSpanFrom[x];
                const callSpanAtt: any = cellToTakeColSpanFrom.CellElement.attribute("colspan");
                let colSpanValue: number|null = null;
                if (callSpanAtt !== null)
                {
                    colSpanValue = Number(callSpanAtt.value);
                }

                for (let y = 0; y < rowSpansToAdd; ++y)
                {
                    ensureRowInTableArray(tableArray, yIdx + y + 1);
                    const rowSpanRow: CellData[] = tableArray[yIdx + y + 1];
                    ensureCellInRow(rowSpanRow, x);
                    const thisPlaceholder: CellData = rowSpanRow[x];
                    thisPlaceholder.CellElement = td;
                    thisPlaceholder.IsColSpanPlaceholder = isColspanOfRootRow;
                    thisPlaceholder.IsRowSpanPlaceholder = true;
                    thisPlaceholder.RowSpan = null;
                    if (colSpanValue !== null)
                    {
                        thisPlaceholder.ColSpan = colSpanValue;
                    }
                    else
                    {
                        thisPlaceholder.ColSpan = 0;
                    }
                }
            }
        }
        ++yIdx;
    })

    if (false)
    {
        dumpTableArray(tableArray);
    }

    //================================================================================================================
    // following is the code that actually generates the cells for the table.

    const openXmlTableElement: any = new XElement(W.tbl,
        new XElement(W.tblPr,
            new XElement(W.tblStyle, new XAttribute(W.val, "TableGrid"),
            new XElement(W.tblBorders,
                new XElement(W.top,
                    new XAttribute(W.val, "single"),
                    new XAttribute(W.sz, "4"),
                    new XAttribute(W.space, "0"),
                    new XAttribute(W.color, "auto")),
                new XElement(W.left,
                    new XAttribute(W.val, "single"),
                    new XAttribute(W.sz, "4"),
                    new XAttribute(W.space, "0"),
                    new XAttribute(W.color, "auto")),
                new XElement(W.bottom,
                    new XAttribute(W.val, "single"),
                    new XAttribute(W.sz, "4"),
                    new XAttribute(W.space, "0"),
                    new XAttribute(W.color, "auto")),
                new XElement(W.right,
                    new XAttribute(W.val, "single"),
                    new XAttribute(W.sz, "4"),
                    new XAttribute(W.space, "0"),
                    new XAttribute(W.color, "auto")),
                new XElement(W.insideH,
                    new XAttribute(W.val, "single"),
                    new XAttribute(W.sz, "4"),
                    new XAttribute(W.space, "0"),
                    new XAttribute(W.color, "auto")),
                new XElement(W.insideV,
                    new XAttribute(W.val, "single"),
                    new XAttribute(W.sz, "4"),
                    new XAttribute(W.space, "0"),
                    new XAttribute(W.color, "auto")),
            ))),
        Enumerable.from(tableArray).select((tableArrayRow: any) =>
        {
            const newRow: any = new XElement(W.tr,
                Enumerable.from(tableArrayRow).select((tableArrayCell: any) =>
                {
                    if (tableArrayCell.IsColSpanPlaceholder === true)
                    {
                        return null;
                    }
                    if (tableArrayCell.IsRowSpanPlaceholder === true)
                    {
                        let colspanAtt: any|null = null;
                        if (!!tableArrayCell.ColSpan)
                        {
                            colspanAtt = new XElement(W.gridSpan, new XAttribute(W.val, tableArrayCell.ColSpan));
                        }
                        const newTc: any = new XElement(W.tc,
                            new XElement(W.tcPr,
                                new XElement(W.vMerge),
                                colspanAtt
                            ),
                            new XElement(W.p));
                        return newTc;
                    }
                    if (tableArrayCell.CellElement.attribute("colspan") !== null && tableArrayCell.CellElement.attribute("rowspan") !== null)
                    {
                        const colspan: number = Number(tableArrayCell.CellElement.attribute("colspan").value);
                        const newTc: any = new XElement(W.tc,
                            new XElement(W.tcPr,
                                new XElement(W.gridSpan, new XAttribute(W.val, colspan)),
                                new XElement(W.vMerge, new XAttribute(W.val, "restart"))),
                            new XElement(W.p,
                                new XElement(W.r,
                                    new XElement(W.t, tableArrayCell.CellElement.value))));
                        return newTc;
                    }
                    if (tableArrayCell.CellElement.attribute("colspan") !== null)
                    {
                        const colspan: number = Number(tableArrayCell.CellElement.attribute("colspan").value);
                        const newTc: any = new XElement(W.tc,
                            new XElement(W.tcPr,
                                new XElement(W.gridSpan, new XAttribute(W.val, colspan))),
                            new XElement(W.p,
                                new XElement(W.r,
                                    new XElement(W.t, tableArrayCell.CellElement.value))));
                        return newTc;
                    }
                    if (tableArrayCell.CellElement.attribute("rowspan") !== null)
                    {
                        const newTc: any = new XElement(W.tc,
                            new XElement(W.tcPr,
                                new XElement(W.vMerge, new XAttribute(W.val, "restart"))),
                            new XElement(W.p,
                                new XElement(W.r,
                                    new XElement(W.t, tableArrayCell.CellElement.value))));
                        return newTc;
                    }
                    if (tableArrayCell.CellElement.hasElements)
                    {
                        const pPr = new XElement(W.pPr);
                        const rPr = new XElement(W.rPr);
                        const cellContents: any[]|null = doTransform(tableArrayCell!.CellElement.elements().toArray(), inTable, styleDefinitionsXDoc, numberingDefinitionsXDoc, pPr, rPr);
                        // add a blank paragraph after a table in a cell - Word requires it.
                        if (Enumerable.from(cellContents).last().name === W.tbl)
                        {
                            cellContents!.push(
                                new XElement(W.p)
                            );
                        }
                        return new XElement(W.tc, cellContents);
                    }
                    else
                    {
                        return new XElement(W.tc,
                            new XElement(W.p,
                                new XElement(W.r,
                                    new XElement(W.t, tableArrayCell.CellElement.value))));
                    }
                })
            );
            return newRow;
        })
    );

    return openXmlTableElement;
}

function ensureCellInRow(thisRow: CellData[], xIdx: number)
{
    while (true)
    {
        if (thisRow.length > xIdx)
        {
            return;
        }
        thisRow.push(new CellData());
        const lastInRow = thisRow[thisRow.length - 1];
        lastInRow.CellElement = null; // this is the td element
        lastInRow.IsColSpanPlaceholder = false;
        lastInRow.IsRowSpanPlaceholder = false;
        lastInRow.RowSpan = null;
        lastInRow.ColSpan = null;
    }
}

function ensureRowInTableArray(cellDatas: any[][], yIdx: number)
{
    while (true)
    {
        if (cellDatas.length > yIdx)
        {
            return;
        }
        var subArray: CellData[] = [];
        cellDatas.push(subArray);
    }
}

function dumpTableArray(tableArray: CellData[][])
{
    const sb = new StringBuilder();
    sb.appendLine("================================================================================================================");
    for (let rowIdx = 0; rowIdx < tableArray.length; ++rowIdx)
    {
        const tableArrayRowForDump: CellData[] = tableArray[rowIdx];
        const padded = rowIdx.toString().padStart(4, '0');
        sb.append(`${padded} `);
        for (let cellIdx = 0; cellIdx < tableArrayRowForDump.length; ++cellIdx)
        {
            const cellData: CellData = tableArrayRowForDump[cellIdx];

            // ColSpan: n
            if (cellData.ColSpan === null)
            {
                sb.append('0');
            }
            else
            {
                sb.append(`${cellData.ColSpan}`);
            }

            // RowSpan: n
            if (cellData.RowSpan === null)
            {
                sb.append('0');
            }
            else
            {
                sb.append(`${cellData.RowSpan}`);
            }

            // IsColSpanPlaceholder N|T|F
            if (cellData.IsColSpanPlaceholder === true)
            {
                sb.append('T');
            }
            else if (cellData.IsColSpanPlaceholder === null)
            {
                sb.append('-');
            }
            else
            {
                sb.append('-');
            }

            // IsRowSpanPlaceholder N|T|F
            if (cellData.IsRowSpanPlaceholder === true)
            {
                sb.append('T');
            }
            else if (cellData.IsRowSpanPlaceholder === null)
            {
                sb.append('-');
            }
            else
            {
                sb.append('-');
            }

            sb.append(' ');
        }
        sb.appendLine('');
    }
    sb.appendLine("================================================================================================================");
    console.log(sb.toString());
}
